import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import {QuestionBase} from "../../../../core/components/dynamic-form/models/question-base";

export class FascicoloConciliazioneStragiudiziale extends FascicoloFull {
  //direzioneTerritoriale: DirezioneTerritorialeLavoro;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }

  get form(): QuestionBase[] {
    return this.baseForm.concat([
      {
        key: 'numeroRuolo',
        label: 'N° ruolo',
        required: false,
        controlType: 'textbox',
        placeholder: 'Inserire N° ruolo',
        size: 'sm-6',
        type: 'number',
        value: this.numeroRuolo
      },
      {
        key: 'annoRuolo',
        label: 'Anno ruolo',
        required: false,
        controlType: 'textbox',
        placeholder: 'Inserire Anno ruolo',
        size: 'sm-4',
        type: 'number',
        value: this.annoRuolo
      },
    ] as QuestionBase[])
  }
}
